<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-6 small-columns-12 calendar-wrapper no-border">
            <mat-label>{{ 'time-off-v3.selectADate' | translate }}</mat-label>
            <input class="d-none" #adjustmentStartDate required matInput type="text" />
            <mat-calendar
                #calendar
                name="calendar"
                [selected]="timeOffTransaction.processedAt"
                (selectedChange)="timeOffTransaction.processedAt = $event; getBalance()"
            ></mat-calendar>
        </mat-form-field>

        <div class="columns-6">
            <div class="app-grid">
                <mat-form-field class="columns-6">
                    <mat-label appRemoveAriaOwns>{{ 'time-off-v3.adjustment' | translate }}</mat-label>
                    <mat-select
                        [ngModel]="addOrSubtract"
                        (ngModelChange)="addOrSubtract = $event; operationChange($event); calculateBalanceAfter()"
                        name="adjustment"
                        #adjustment
                        required
                    >
                        <mat-option [value]="'add'">{{ 'time-off-v3.add' | translate }}</mat-option>
                        <mat-option [value]="'subtract'">{{ 'time-off-v3.subtract' | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="columns-6">
                    <mat-label>{{
                        'time-off-v3.amountUnitOfTime' | translate: { amount: (unitOfTime | appTranslate | titlecase) }
                    }}</mat-label>
                    <input
                        [ngModel]="amount"
                        (ngModelChange)="setAmount($event); calculateBalanceAfter()"
                        name="date"
                        type="number"
                        #amount
                        required
                        matInput
                    />
                </mat-form-field>

                <mat-form-field class="columns-12">
                    <mat-label>{{ 'time-off-v3.addNote' | translate }}</mat-label>
                    <textarea
                        name="note"
                        [(ngModel)]="timeOffTransaction.description"
                        placeholder="{{ 'time-off-v3.egSickDaysToBeUsedWhenIll' | translate }}"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="6"
                        matInput
                    ></textarea>
                </mat-form-field>

                <div class="columns-6">
                    <h4 class="left-align">{{ 'time-off-v3.balanceBefore' | translate }}</h4>
                    <h3 class="left-align balance">
                        {{ balance | i18nNum }} {{ unitOfTime | appTranslate | titlecase }}
                    </h3>
                </div>

                <div class="columns-6">
                    <h4 class="left-align">
                        {{ 'time-off-v3.balanceAfter' | translate }}
                        <ui-info text="{{ 'time-off-v3.estimationOnly' | translate }}"> </ui-info>
                    </h4>
                    <h3 class="left-align balance">
                        {{ balanceAfter | number: '1.1-2' }} {{ unitOfTime | appTranslate | titlecase }}
                    </h3>
                </div>
            </div>
        </div>
    </div>
</form>
